var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 49,
    viewBox: "0 0 89 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2219 0.155029L49.0281 0.155029L73.3381 24.465L49.0281 48.775H64.2219L88.5319 24.465L64.2219 0.155029ZM39.9119 0.155119L24.7181 0.155119L49.0281 24.4651L24.7181 48.7751L39.9119 48.7751L64.2218 24.4651L39.9119 0.155119ZM0.408142 0.155119L15.6019 0.155119L39.9119 24.4651L15.6019 48.7751H0.408142L24.7181 24.4651L0.408142 0.155119Z",
    fill: "url(#paint0_linear_1_2549)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2549",
    x1: 88.5319,
    y1: 24.465,
    x2: 15.6019,
    y2: 24.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD053",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.12ee9aedc9c2439dcb534b566f6676ce.svg";
export { ForwardRef as ReactComponent };